import { Box, Typography } from '@mui/material';
import AdminLayout from '../../components/admin/AdminLayout';

const SystemMonitoringAnalyticsPage = () => {
  return (
    <AdminLayout>
      <Box sx={{ p: 3 }}>
        <Typography variant="h4" color="text.primary" gutterBottom>
          System Monitoring & Analytics
        </Typography>
        <Typography variant="body1" color="text.secondary">
          System monitoring and analytics content will be implemented here.
        </Typography>
      </Box>
    </AdminLayout>
  );
};

export default SystemMonitoringAnalyticsPage; 